import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, ListHeader, NewCreditAnaCredit, MonthlyCreditsAnaCredit, AnaCreditExportList } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ExportAnaCredit = function ExportAnaCredit(_ref) {
  var match = _ref.match;
  var NewCreditTab = useCallback(function () {
    return ___EmotionJSX(NewCreditAnaCredit, null);
  }, []);
  var MonthlyCreditsTab = useCallback(function () {
    return ___EmotionJSX(MonthlyCreditsAnaCredit, null);
  }, []);
  var ExportListTab = useCallback(function () {
    return ___EmotionJSX(AnaCreditExportList, null);
  }, []);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0410\u043D\u0430\u041A\u0440\u0435\u0434\u0438\u0442"
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/new-credit-ana-credit",
    component: NewCreditTab,
    label: "\u0414\u043D\u0435\u0432\u0435\u043D \u043E\u0442\u0447\u0435\u0442 \u043D\u0430 \u043D\u043E\u0432\u043E\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438 \u0438 \u0437\u0430\u043A\u0440\u0438\u0442\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/monthly-credits-ana-credit",
    component: MonthlyCreditsTab,
    label: "\u041C\u0435\u0441\u0435\u0447\u0435\u043D \u043E\u0442\u0447\u0435\u0442 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0438\u0442\u0435"
  }), ___EmotionJSX(Tab, {
    url: "/anaCredit-exports",
    component: ExportListTab,
    label: "\u0421\u043F\u0438\u0441\u044A\u043A \u0435\u043A\u043F\u043E\u0440\u0442\u0438"
  })));
};

ExportAnaCredit.propTypes = {
  match: PropTypes.object
};
export default ExportAnaCredit;